import AddTenant from './AddTenant';

export default AddTenant;
